import * as React from 'react';

export default function NotFound() {

    return (<div className="content-body container">
        Not found
    </div>);
}

